import type { ReactNode } from "react";

import type { User } from "../../../../models/User";
import type { WPApiBlock } from "../../../../models/WPContentBlock";
import type { WPProductConfig } from "../../../../models/WPProductConfig";
import type { ApiClient } from "../../../../utils/api/_makeApiClient";

export async function fetchPracticeTests(
  apiClient: ApiClient,
  user: User | undefined,
  product: WPProductConfig | undefined,
  block: WPApiBlock,
): Promise<ReactNode | null> {
  if (!user || !product) {
    return null;
  }

  const [testGroups, { PracticeTests }] = await Promise.all([
    apiClient.fetchPracticeTests(user, product),
    import("../../../components/blocks/PracticeTests/PracticeTests"),
  ]);

  return <PracticeTests model={block} testGroups={testGroups} />;
}
